import React from "react";

import { useForm } from "react-hook-form";

import Modal from "../Shared/Modal";
import useUserContext from "../../contexts/UserContext";
import { ButtonInput } from "../Shared/Inputs/ButtonInput";
import useNotification from "../notification/useNotifications";
import { StyledTextInput } from "../Shared/StyledInputs/StyledTextInput";
import { useEmailSettingsMutations } from "../../data/emailSettings/useEmailSettingsMutations";

interface SendTestModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function SendTestModal({ open, setOpen}: SendTestModalProps) {
  const { user: { agency } } = useUserContext();
  const { sendTest } = useEmailSettingsMutations(agency.id);
  const { register, handleSubmit } = useForm<{ email: string }>({ defaultValues: { email: "" } });
  const { addNotification } = useNotification();

  const onSubmit = (data: { email: string }) => {
    sendTest.mutate({
      ...data,
    }, {
      onSuccess: () => {
        addNotification({ primaryText: "Test email sent successfully", variant: "success" });
      },
      onError: () => {
        addNotification({ primaryText: "Failed to send test email", variant: "error" });
      },
      onSettled: () => setOpen(false)
    });
  };

  return (
    <Modal open={open} setOpen={setOpen} width={"max-w-xl"}>
      <h3 className="text-lg px-2 leading-6 font-medium text-gray-900">
        Send Test Email
      </h3>
      <div className="mt-2 p-2 max-h-[70vh] overflow-y-auto">
        <p className="text-sm text-gray-500">
          This will send a test email to the specified email address. The
          email will be sent immediately and will not be tracked in any way.
        </p>
        <form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit)(e) }} className="mt-4">
          <StyledTextInput
            label="Email Address"
            registerName="email"
            register={register}
            colsClass=""
          />
          {/* @ts-ignore */}
          <ButtonInput
            isSubmit={true}
            label="Send Test Email"
            classes="mt-6"
          />
        </form>
      </div>
    </Modal>
  );
}